<template>
    <b-modal 
    :active="searchModalBool" 
    :on-cancel="emitCloseModal" 
    can-cancel="[x, escape]" 
    style="overflow:visible;" 
    scroll="keep">
        <div class="modal-card">
            <div class="modal-card-body">
                <div class="columns">
                    <div class="column is-full has-text-centered">
                        <b-field class="subir">
                            <b-autocomplete
                            rounded
                            expanded
                            autocomplete="none"
                            v-model="searchQ"
                            :data="results"
                            :loading="loading"
                            @input="fetchResults"
                            placeholder="Buscar..."
                            icon="search">
                            <template slot-scope="props" style="position:absolute;">
                                <a v-if="props.option.getDetailUrl" :href="props.option.getDetailUrl">
                                    <div class="media">
                                        <div class="media-left">
                                            <img width="32" :src="props.option.getImage" alt="logo">
                                        </div>
                                        <div class="media-content">
                                            {{ props.option.title }}
                                            <br>
                                        </div>
                                    </div>
                                </a>
                                <a v-else :href="props.option.getProdListUrl">
                                    <div class="media">
                                        
                                        <div class="media-content">
                                            {{ props.option.title }}
                                            <br>
                                        </div>
                                    </div>
                                </a>
                            </template>
                            <template slot="empty">No encontramos nada para esa busqueda...</template>
                            </b-autocomplete>
                            <p class="control">
                                <b-button class="button is-custom"
                                rounded
                                @click="redirectToResults">
                                    <b-icon icon="search"></b-icon>
                                </b-button>
                            </p>
                        </b-field>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { getHandler, debounce } from '../../../../services/http'
export default {
    props:{
        searchEndpoint:{
            type:String,
            default:""
        },
        searchResultsUrl:{
            type:String,
            default:""
        },
        searchModalBool:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            results:[],
            searchQ:"",
            loading:false
        }
    },
    methods:{
        emitCloseModal(){
            this.$emit("closeModal")
        },
        fetchResults: debounce(async function(){
            if(this.searchQ.length > 2){
                var url = this.searchEndpoint + `?search_q=${this.searchQ}`
                this.loading = true
                this.results = await getHandler(url, {error:false, success:false})
                this.loading = false
                console.log(this.results)
            }
        }, 
        500),
        redirectToResults(){
            window.location.href = this.searchResultsUrl + `?search_q=${this.searchQ}`
        }
    }
}
</script>

<style lang="scss" scoped>

.is-custom{
    background:var(--primary);
    color:var(--text-color);
    
}

.modal-card{
    width: auto; 
    margin: 0 auto; 
    height: 800px;
    overflow:visible;
}
.modal-card-body{
    background: transparent;
    overflow:visible;
    border-radius:10px; 
    height: 800px;
}
.subir{
    margin-top:0px;
}
@media (max-width: 767px){
    .subir{
        margin-top:-20px;
    }
}
</style>